import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Property 1=24" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M15 10V18H9V10H15ZM14 4H10L9 5H7C6.44772 5 6 5.44772 6 6V7H18V6C18 5.44772 17.5523 5 17 5H15L14 4ZM17 8H7V18C7 19.1 7.9 20 9 20H15C16.1 20 17 19.1 17 18V8Z", fill: "currentColor", fillOpacity: 1 })));
const ForwardRef = forwardRef(SvgDelete);
export default ForwardRef;
